<script setup>
import { AbcIcon } from "@ordbogen-npm/abc-dsk";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import IconChevronRight from "@/components/icons/white/IconWhiteChevronRight.vue";
import WordListDeleteModal from "@/components/vocabularyTrainer/WordListDeleteModal.vue";
import WordListEditModal from "@/components/vocabularyTrainer/WordListEditModal.vue";

defineProps({
  shareCode: {
    type: String,
    required: true
  },
  listName: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["editSuccess"]);

const { t } = useI18n();

const isDeleteModalOpen = ref(false);
const isEditModalOpen = ref(false);

const onEditSuccess = (value) => {
  isEditModalOpen.value = false;
  emit("editSuccess", value);
};
</script>

<template>
  <div class="word-list-menu__container">
    <button class="word-list-menu__menu-item" @click="isEditModalOpen = true">
      <AbcIcon name="edit" color="primary" />
      <p class="mb-0 pl-2 text-left">{{ t("vocab.vocabList.wordListEdit.menuText") }}</p>
      <IconChevronRight class="word-list-menu__chevron" />
      <WordListEditModal
        :is-open="isEditModalOpen"
        :share-code="shareCode"
        :name="listName"
        @cancel="isEditModalOpen = false"
        @success="onEditSuccess($event)"
      />
    </button>
    <button class="word-list-menu__menu-item" @click="isDeleteModalOpen = true">
      <AbcIcon name="trash" color="red" />
      <p class="mb-0 pl-2 text-left">{{ t("vocab.vocabList.wordListDelete.menuText") }}</p>
      <IconChevronRight class="word-list-menu__chevron" />
      <WordListDeleteModal
        :is-open="isDeleteModalOpen"
        :share-code="shareCode"
        :name="listName"
        @cancel="isDeleteModalOpen = false"
      />
    </button>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.word-list-menu__container {
  width: 170px;
  max-width: 100%;
  padding: 10px;
  background-color: @colors[@white];
  box-shadow: 6px 6px 20px rgba(0, 0, 0, 0.1);

  #media-breakpoint-up(md, {
    width: 190px;
  });
}

.word-list-menu__menu-item {
  display: grid;
  grid-template-columns: 20px 1fr 10px;
  align-items: center;
  width: 100%;
  margin-bottom: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background-color: @colors[@white];
  color: @colors[@black];
  font-size: 0.875rem;
  line-height: 1.25rem;

  &:hover {
    background-color: rgb(@theme-colors[@grey][10]);
    cursor: pointer;
  }

  &:hover .word-list-menu__chevron {
    display: block;
  }

  &:last-of-type {
    margin: 0;
  }
}

.word-list-menu__chevron {
  display: none;
  align-self: center;
  width: 10px;
  height: 10px;
  color: rgb(@theme-colors[@grey][50]);
}
</style>
